var map = {
	"./decidim/avatar-multiuser.png": 47884,
	"./decidim/brands/google.svg": 38979,
	"./decidim/cc-badge.png": 46622,
	"./decidim/decidim-logo.svg": 6510,
	"./decidim/default-avatar.svg": 51354,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 31342,
	"./decidim/icons.svg": 46381,
	"./decidim/pattern.png": 75882,
	"./decidim/placeholder-card-g.svg": 31015,
	"./decidim/placeholder-card-l.svg": 29404,
	"./decidim/placeholder.jpg": 99523,
	"./decidim/remixicon.symbol.svg": 79499,
	"./decidim/vendor/leaflet/layers-2x.png": 79182,
	"./decidim/vendor/leaflet/layers.png": 4405,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 88380,
	"./decidim/vendor/leaflet/marker-icon.png": 89067,
	"./decidim/vendor/leaflet/marker-shadow.png": 95056,
	"./decidim/vendor/social-share-button/douban.svg": 35450,
	"./decidim/vendor/social-share-button/email.svg": 85783,
	"./decidim/vendor/social-share-button/facebook.svg": 26377,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 80459,
	"./decidim/vendor/social-share-button/hacker_news.svg": 70331,
	"./decidim/vendor/social-share-button/linkedin.svg": 18727,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 80288,
	"./decidim/vendor/social-share-button/pinterest.svg": 91513,
	"./decidim/vendor/social-share-button/reddit.svg": 34665,
	"./decidim/vendor/social-share-button/telegram.svg": 41808,
	"./decidim/vendor/social-share-button/tumblr.svg": 75463,
	"./decidim/vendor/social-share-button/twitter.svg": 79878,
	"./decidim/vendor/social-share-button/vkontakte.svg": 63352,
	"./decidim/vendor/social-share-button/wechat.svg": 59139,
	"./decidim/vendor/social-share-button/whatsapp.svg": 6491,
	"./decidim/vendor/social-share-button/x.svg": 79471,
	"./decidim/vendor/social-share-button/xing.svg": 57065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31723;